function normalizeBirthDate(value) {
    if (value == null || value === '') return null;
    const str = String(value).trim();
    if (!str) return null;
    if (/^\d{4}-\d{2}-\d{2}$/.test(str)) return str;
    const match = str.match(/^(\d{4}-\d{2}-\d{2})/);
    if (match) return match[1];
    const parsed = new Date(str);
    if (!Number.isNaN(parsed.getTime())) {
        return parsed.toISOString().slice(0, 10);
    }
    return null;
}

export function buildProfileFormData({
    firstName,
    middleName,
    lastName,
    phoneCode,
    phoneNumber,
    birthDate,
    majorId,
    academicDegreeId,
    email,
    language,
    image,
}) {
    const formData = new FormData();

    if (firstName != null) formData.append('first_name', firstName);
    if (middleName != null) formData.append('middle_name', middleName);
    if (lastName != null) formData.append('last_name', lastName);
    if (phoneCode) formData.append('phone_code', phoneCode);
    if (phoneNumber) formData.append('phone', phoneNumber);
    const normalizedBirthDate = normalizeBirthDate(birthDate);
    if (normalizedBirthDate) formData.append('birth_date', normalizedBirthDate);
    if (majorId != null && majorId !== '') formData.append('major_id', majorId);
    if (academicDegreeId != null && academicDegreeId !== '') formData.append('academic_degree_id', academicDegreeId);
    if (email) formData.append('email', email);
    if (language) formData.append('language', language);
    if (image) formData.append('image', image);

    return formData;
}
